var chunkMapping = {
	"994": [
		80994
	],
	"1180": [
		31180
	],
	"1525": [
		31525
	],
	"1573": [
		11573
	],
	"1664": [
		1664
	],
	"1961": [
		11961
	],
	"2303": [
		92303
	],
	"2326": [
		22326
	],
	"2379": [
		72379
	],
	"2429": [
		52429
	],
	"2585": [
		2585
	],
	"2911": [
		32911
	],
	"2984": [
		32984
	],
	"3994": [
		13994
	],
	"4225": [
		74241,
		54715,
		4004
	],
	"4863": [
		24863
	],
	"5147": [
		95147
	],
	"5253": [
		59793
	],
	"5309": [
		65309
	],
	"5783": [
		45783
	],
	"6068": [
		16068
	],
	"6711": [
		6711
	],
	"7662": [
		97662
	],
	"8199": [
		48199
	],
	"8581": [
		78581
	],
	"8680": [
		38680
	],
	"9117": [
		9117
	],
	"9138": [
		97011
	],
	"9533": [
		69533
	],
	"9803": [
		69803
	],
	"9846": [
		99846
	],
	"9853": [
		79853
	]
};
var idToExternalAndNameMapping = {
	"1664": [
		"default",
		"./ImagesCarousel",
		49523
	],
	"2585": [
		"default",
		"./Checkbox",
		49523
	],
	"4004": [
		"default",
		"./Toast",
		49523
	],
	"6711": [
		"default",
		"./I18nService",
		49523
	],
	"9117": [
		"default",
		"./DefaultSearchBar",
		49523
	],
	"11573": [
		"default",
		"./ButtonDropdown",
		49523
	],
	"11961": [
		"default",
		"./PageDescription",
		49523
	],
	"13994": [
		"default",
		"./Footer",
		49523
	],
	"16068": [
		"default",
		"./ConfirmTrackingModal",
		49523
	],
	"22326": [
		"default",
		"./SearchBar",
		49523
	],
	"24863": [
		"default",
		"./ModalKebab",
		49523
	],
	"31180": [
		"default",
		"./FormAttributeItem",
		49523
	],
	"31525": [
		"default",
		"./FooterActions",
		49523
	],
	"32911": [
		"default",
		"./StatusTags",
		49523
	],
	"32984": [
		"default",
		"./QshipMap",
		49523
	],
	"38680": [
		"default",
		"./TablePaginationFullPage",
		49523
	],
	"45783": [
		"default",
		"./DateRangePickerField",
		49523
	],
	"48199": [
		"default",
		"./ModalStatus",
		49523
	],
	"52429": [
		"default",
		"./MultiSelectDropdown",
		49523
	],
	"54715": [
		"default",
		"./Theme",
		49523
	],
	"59793": [
		"default",
		"./PopConfirm",
		49523
	],
	"65309": [
		"default",
		"./EmptyState",
		49523
	],
	"69533": [
		"default",
		"./TrackListing",
		49523
	],
	"69803": [
		"default",
		"./NavigationHorizontalBar",
		49523
	],
	"72379": [
		"default",
		"./ShipmentTrackIDSearchBar",
		49523
	],
	"74241": [
		"default",
		"./Button",
		49523
	],
	"78581": [
		"default",
		"./RadioGroupWithBox",
		49523
	],
	"79853": [
		"default",
		"./Text",
		49523
	],
	"80994": [
		"default",
		"./PaginationQship",
		49523
	],
	"92303": [
		"default",
		"./ShipmentTrackIDSearchBarMobile",
		49523
	],
	"95147": [
		"default",
		"./SingleDropdownAndMulti",
		49523
	],
	"97011": [
		"default",
		"./TabsBar",
		49523
	],
	"97662": [
		"default",
		"./QshipDetailMap",
		49523
	],
	"99846": [
		"default",
		"./HistoryListing",
		49523
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}